import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Factory, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** "Factory run started" — moves every confirmed, unshipped order to In production and emails each customer. */
export const ProductionRunButton = ({ headers, orders, onDone }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [count, setCount] = useState(null);
  const pending = orders.filter((o) => o.payment_status === "paid" && !o.tracking && o.fulfillment !== "in_production").length;
  useEffect(() => { setCount(pending); }, [pending]);

  const run = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/orders/production-all`, {}, { headers });
      onDone(r.data);
      setOpen(false);
      toast.success(`${r.data.updated} orders now in production · ${r.data.emailed} customers emailed`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not start the production run.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button data-testid="production-run-btn" onClick={() => setOpen(true)} disabled={!count} className="h-10 px-4 rounded-full bg-[#0a0a0b] hover:bg-[#ff2a85] text-white font-mono-d text-[10px] uppercase tracking-[0.2em] flex items-center gap-2 disabled:opacity-40 transition-colors">
        <Factory size={13} /> Start production run{count ? ` (${count})` : ""}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="production-run-dialog" className="rounded-3xl max-w-md">
          <DialogHeader>
            <DialogTitle className="font-display font-extrabold uppercase">Factory run started?</DialogTitle>
            <DialogDescription>
              {count} confirmed, unshipped {count === 1 ? "order" : "orders"} will move to <strong>In production</strong>. Each customer gets the "your piece is in production" email and their Track Order timeline lights up the second step. Orders already in production or shipped are left alone.
            </DialogDescription>
          </DialogHeader>
          <div className="flex justify-end gap-2 pt-2">
            <button data-testid="production-run-cancel" onClick={() => setOpen(false)} className="h-10 px-5 rounded-full border border-[#e3e2dc] hover:border-[#0a0a0b] text-xs">Not yet</button>
            <button data-testid="production-run-confirm" onClick={run} disabled={busy} className="h-10 px-5 rounded-full bg-[#ff2a85] hover:bg-[#e60067] text-white text-xs font-medium disabled:opacity-50 flex items-center gap-2">
              {busy && <Loader2 size={12} className="animate-spin" />} Mark {count} in production
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
